import { useState } from 'react';
import { Wrapper, Track, Slide, ArrowButton, Dots, Dot } from './styles';

// The App Store set, in the order the listing shows them, resized to 640px and JPEG'd — the
// originals are 1290x2796 PNGs at over a megabyte each, which is the right thing to hand Apple
// and the wrong thing to put on a page. The carousel draws nothing at all while the list is
// empty rather than framing broken images.
const SCREENSHOTS: string[] = [
    'assets/screenshot-hero.jpg',
    'assets/screenshot-catch.jpg',
    'assets/screenshot-propose.jpg',
    'assets/screenshot-logbook.jpg',
    'assets/screenshot-story.jpg',
    'assets/screenshot-share.jpg',
];

const ALT = [
    'The Ideas screen, with trips and experiences waiting to be given a date',
    'Catching a new idea by typing one line',
    'Ten AI proposals, shaped by what you like',
    'The logbook of everything already done',
    'A logged story, with its own words and photographs',
    'Sharing a story as a link',
];

export const hasScreenshots = SCREENSHOTS.length > 0;

const Carousel = () => {
    const [index, setIndex] = useState(0);

    if (!hasScreenshots) return null;

    return (
        <Wrapper>
            <ArrowButton
                onClick={() => setIndex(i => Math.max(0, i - 1))}
                disabled={index === 0}
                aria-label="Previous screenshot"
            >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M15 18l-6-6 6-6" />
                </svg>
            </ArrowButton>
            <Track>
                <Slide style={{ transform: `translateX(-${index * 100}%)` }}>
                    {SCREENSHOTS.map((src, i) => (
                        // Only the first is eager: the rest are off-screen behind a transform,
                        // and six phone screenshots is half a megabyte nobody has asked for yet.
                        <img
                            key={i}
                            src={src}
                            alt={ALT[i]}
                            loading={i === 0 ? 'eager' : 'lazy'}
                            width={640}
                            height={1388}
                        />
                    ))}
                </Slide>
            </Track>
            <ArrowButton
                onClick={() => setIndex(i => Math.min(SCREENSHOTS.length - 1, i + 1))}
                disabled={index === SCREENSHOTS.length - 1}
                aria-label="Next screenshot"
            >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M9 18l6-6-6-6" />
                </svg>
            </ArrowButton>
            <Dots>
                {SCREENSHOTS.map((_, i) => (
                    <Dot key={i} $active={i === index} onClick={() => setIndex(i)} />
                ))}
            </Dots>
        </Wrapper>
    );
};

export default Carousel;
